import React from 'react';
import './ArticlesSection.scss';

const ArticlesSection = ({ articles, translation, originUrlRedirection, viewAllRedirection,totalArticles }) => {
    const parseTitle = (title) => {
        const parts = (title || '').split(/(<em>.*?<\/em>)/g);
        return parts.map((part, index) =>
            part.startsWith("<em>") ? (
                <span key={index} >
                {part.replace(/<\/?em>/g, "")}
            </span>
            ) : (
                part
            )
        );
    };
    if (!articles || articles.length === 0) return null;
    return (
        <div>
            <h4>{translation('articles')}({totalArticles})</h4>
            <ul>
                {articles.map((article, index) => (
                    <li key={index} className="articles">
                        <a className="articles" href={originUrlRedirection + article.url}>
                            {parseTitle(article.title?.replace(/&amp;/g, '&'))}
                        </a>
                    </li>
                ))}
            </ul>
            <button
                className="view-all-articles"
                onClick={() => viewAllRedirection('articles')}
            >
                {translation('view_all_articles')} >
            </button>
        </div>
    );
};

export default ArticlesSection;
